import React from 'react';
import PropTypes from 'prop-types';
import Transitions from '../core';

export default function Fade(props) {
  return <Transitions type='fade' {...props} />;
}

Fade.propTypes = {
  start: PropTypes.bool,
  delay: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  duration: PropTypes.number,
};
